/** Input showcase data — from sf-react-app */
import React from 'react';

const CURRENCY_CODE_OPTIONS = [
  { value: 'GBP', label: 'GBP' },
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
];

const PHONE_AFFIX_SELECT_OPTIONS = [
  { value: 'IN', label: 'IN', subtitle: '+91', avatar: <span aria-hidden>🇮🇳</span> },
  { value: 'US', label: 'US', subtitle: '+1', avatar: <span aria-hidden>🇺🇸</span> },
  { value: 'GB', label: 'GB', subtitle: '+44', avatar: <span aria-hidden>🇬🇧</span> },
];

export { CURRENCY_CODE_OPTIONS, PHONE_AFFIX_SELECT_OPTIONS };